import React, { useEffect, useState } from "react";
import { Button, ListItemIcon, MenuItem, Typography } from "@mui/material";
import CommonTable from "./sharedComponents/CommonTable";
import { useNavigate } from "react-router-dom";
import { getFeatureViewList } from "../service/ApiService";

const FeaturesView: React.FC = () => {
  const [FeaturesViewList, setFeaturesViewList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleClick = (record: any) => {
    navigate(`/flowsView?featureId=${record.id}`);
  };


  useEffect(() => {
    getFeaturesList();
  }, []);

  const getFeaturesList = () => {
    setIsLoading(true);
    getFeatureViewList()
      .then((response) => {
        if (response && response.data && response.data.length > 0) {
          const filteredList = response.data.filter((item: any) => item.isEnabled);
          setFeaturesViewList(filteredList);
        }
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }
  
  const columns: any = [
    {
      accessorKey: "id",
      header: "ID",
      size: 100,
    },
    {
      accessorKey: "name",
      header: "Name",
      size: 350,
      accessorFn: (row: any) => (
        <span
          className="pointer cursor-pointer hover:text-blue-600"
          onClick={() => handleClick(row)}
        >
          {row.name}
        </span>
      ),
    },
    {
      accessorKey: "description",
      header: "Description",
      size: 200,
    },
  ];

  const renderCustomToolbar = () => {
    return <Typography variant="h6">{"Features"}</Typography>;
  };

  return (
    <div className="container mx-auto">
      <CommonTable
        columnsList={columns}
        dataList={FeaturesViewList}
        renderCustomToolbar={renderCustomToolbar}
        isLoading={isLoading}
      />
    </div>
  );
};

export default FeaturesView;
